import { render, staticRenderFns } from "./overpass.vue?vue&type=template&id=17a85a75&scoped=true&"
import script from "./overpass.vue?vue&type=script&lang=js&"
export * from "./overpass.vue?vue&type=script&lang=js&"
import style0 from "./overpass.vue?vue&type=style&index=0&id=17a85a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a85a75",
  null
  
)

export default component.exports